/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * all possible refund statuses in the system
 */
export type RefundStatusEnum = 'NOT_STARTED' | 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export const RefundStatusEnum = {
    NotStarted: 'NOT_STARTED' as RefundStatusEnum,
    Pending: 'PENDING' as RefundStatusEnum,
    Completed: 'COMPLETED' as RefundStatusEnum,
    Failed: 'FAILED' as RefundStatusEnum,
    Cancelled: 'CANCELLED' as RefundStatusEnum
};

